export const vanNumber = (group, index = 0) => Number(group?.planejamento_van_numero) || index + 1;
export const vanReady = (group) => Boolean(group?.motorista?.id && group?.veiculo?.id && group.pessoas?.length
  && group.pessoas.length <= Number(group.veiculo.capacidade || 15));
export const planningDispatchIndexes = (groups, marked) => groups.flatMap((_,index) => marked.has(index) ? [index] : []);

export const vanPendingItems = (group) => {
  const pending = [];
  if (!group?.motorista?.id) pending.push('Escolha o motorista');
  if (!group?.veiculo?.id) pending.push('Escolha o veículo');
  if (!group?.pessoas?.length) pending.push('Adicione passageiros');
  if (group?.veiculo?.id && group.pessoas?.length > Number(group.veiculo.capacidade || 15)) {
    pending.push(`Há ${group.pessoas.length} passageiros para ${Number(group.veiculo.capacidade || 15)} lugares`);
  }
  return pending;
};

export const reviewFingerprint = (group = {}) => JSON.stringify({
  programacao: group.programacao_responsavel_id, data: group.data, horario: group.horario, trecho: group.trecho,
  motorista: [group.motorista?.id, group.motorista?.nome, group.motorista?.telefone],
  veiculo: [group.veiculo?.id, group.veiculo?.placa, group.veiculo?.capacidade],
  pessoas: (group.pessoas || []).map((p) => [p.programacao_passageiro_id, p.id_pedido_origem,
    p.nome, p.rua, p.numero, p.bairro, p.cidade, p.telefone]),
});
export const preserveReview = (previous, next) => reviewFingerprint(previous) === reviewFingerprint(next) ? next
  : { ...next, conferida: false, conferencia_solicitada: false, conferida_em: null, conferida_por: null };
export const numberPlanningGroups = (groups, route) => {
  let next = Math.max(Number(route?.payload?.proximo_numero_van) || 1,
    ...groups.map((group) => (Number(group.planejamento_van_numero) || 0) + 1),
    ...(route?.vans_enviadas || []).map((van) => vanNumber(van.grupo) + 1));
  return groups.map((group) => group.planejamento_van_numero ? group : { ...group, planejamento_van_numero: next++ });
};
export const groupsFingerprint = (groups = []) => JSON.stringify(groups.map((group) => [
  group.planejamento_grupo_id || null, group.planejamento_van_numero || null,
  group.regiao, Boolean(group.conferida), reviewFingerprint(group),
]));
export const regionsFingerprint = (groups = []) => JSON.stringify(groups.map((group) => [group.regiao,
  Number(group.qtdVeiculos) || 1, group.pessoas.map((person) => person.programacao_passageiro_id || person.id),
  groupsFingerprint(group.subgrupos || []),
]).sort((a, b) => a[0].localeCompare(b[0])));

export const publishedVanStatus = (van) => {
  if (van.progress_status === 'failed') return 'failed';
  if (van.progress_status === 'sent') return 'sent';
  if (['sending','awaiting','pending','queued'].includes(van.progress_status)) return 'pending';
  if (van.envio_status === 'enviado_manual') return 'sent';
  if (['failed', 'dead_letter'].includes(van.notification_status) || ['falha', 'falha_definitiva'].includes(van.envio_status)) return 'failed';
  if (['pending','processing','accepted','retry'].includes(van.notification_status)) return 'pending';
  if (van.status === 'enviada') return 'sent';
  if (['enfileirado_meta', 'enfileirando_meta', 'disparando_webhook'].includes(van.envio_status)) return 'pending';
  return 'prepared';
};
export const publishedVanStatusLabel = (van) => ({ failed: 'Falha no envio', sent: van.motorista_respondeu ? 'Motorista respondeu' : 'Enviada',
  pending: 'Em processamento', prepared: 'Envio pendente' }[publishedVanStatus(van)]);
export const planningSummary = (groups, published = []) => ({
  total: groups.length + published.length,
  incomplete: groups.filter((group) => !vanReady(group)).length,
  ready: groups.filter((group) => vanReady(group) && !group.conferida).length,
  reviewed: groups.filter((group) => vanReady(group) && group.conferida).length,
  sent: published.filter((van) => publishedVanStatus(van) === 'sent').length,
  processing: published.filter((van) => publishedVanStatus(van) === 'pending').length,
  failed: published.filter((van) => ['failed', 'prepared'].includes(publishedVanStatus(van))).length,
});
